export function useKeyboardParagraphNavigation(
  legalTextSlug: MaybeRefOrGetter<string>,
  previousSlug: MaybeRefOrGetter<string | undefined>,
  nextSlug: MaybeRefOrGetter<string | undefined>
) {
  const navigate = useNavigate();
  const { href: previousLink } = useParagraphLink({
    legalTextSlug,
    paragraphSlug: previousSlug,
  });
  const { href: nextLink } = useParagraphLink({
    legalTextSlug,
    paragraphSlug: nextSlug,
  });

  useEventListener("keydown", (e) => {
    if (document.activeElement !== document.body) return;
    const { key, altKey, ctrlKey, metaKey, shiftKey } = e;
    if ([altKey, ctrlKey, metaKey, shiftKey].some((pressed) => pressed)) {
      return;
    }

    if (key === "ArrowLeft") {
      return navigate(previousLink.value);
    } else if (key === "ArrowRight") {
      return navigate(nextLink.value);
    }
  });
}
